import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useIntl } from 'react-intl'
import useLoyaltyOrderEsimBenefitView from 'loyalty/hooks/useLoyaltyOrderViewEsimData'
import LoyaltyEsimDetailsContent from './LoyaltyEsimDetailsContent'

interface LoyaltyEsimDetailsModalProps {
  /** When set (e.g. from order/booking-confirmation Redeem), show only this order's code (single-code variation). */
  orderId?: string
}

function LoyaltyEsimDetailsModal({ orderId }: LoyaltyEsimDetailsModalProps) {
  const intl = useIntl()
  const esimBenefitView = useLoyaltyOrderEsimBenefitView(orderId)
  const isComplimentaryPackage = !esimBenefitView?.purchasedUpsell

  const title = isComplimentaryPackage
    ? intl.formatMessage({
        id: 'JQiTXySxKAe5wYCZyzLz',
        defaultMessage: 'Free Data Roaming',
        description: 'Title heading for the eSIM details and redemption modal dialog',
      })
    : intl.formatMessage({
        id: '5dOehWDGBQ9UYpW6ckYE',
        defaultMessage: 'Data Roaming',
        description: 'Title heading for the eSIM details modal when the member has paid to upgrade their package',
      })

  return (
    <ModalBase size="L">
      <ModalHeader title={title} />
      <ModalBody>
        <LoyaltyEsimDetailsContent orderId={orderId} />
      </ModalBody>
    </ModalBase>
  )
}

export default LoyaltyEsimDetailsModal
